/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureExecMaterialsModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    authorId: lc.get(data, 'author_id'),
    taskExecId: lc.get(data, 'task_exec_id'),
    execLogId: lc.get(data, 'exec_log_id'),
    fileName: lc.get(data, 'file_name'),
    filePreviewUrl: lc.get(data, 'file_preview_url'),
    fileUrl: lc.get(data, 'file_url'),
    status: lc.get(data, 'status'),
    createdAt: lc.get(data, 'created_at')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksExecsMaterials/restructuring/index.js